import React, { forwardRef } from 'react';
const ModalHeader = (StyledModalHeader) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledModalHeader ref={ref} {...props}>
        {children}
      </StyledModalHeader>);
});
export default ModalHeader;
